import React from 'react';

type IconProps = {
    width?: number;
    height?: number;
};

const IconCircleCheck: React.FC<IconProps> = () => {
    return (
        <svg
            width="50"
            height="50"
            viewBox="0 0 50 50"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <circle cx="25" cy="25" r="25" fill="white" />
            <path
                d="M36.1196 19.4945L22.1195 33.4946C22.0383 33.5759 21.9418 33.6404 21.8356 33.6845C21.7293 33.7285 21.6155 33.7512 21.5005 33.7512C21.3855 33.7512 21.2716 33.7285 21.1654 33.6845C21.0592 33.6404 20.9627 33.5759 20.8814 33.4946L14.7564 27.3695C14.5922 27.2054 14.5 26.9827 14.5 26.7505C14.5 26.5183 14.5922 26.2956 14.7564 26.1314C14.9206 25.9672 15.1433 25.875 15.3755 25.875C15.6077 25.875 15.8304 25.9672 15.9945 26.1314L21.5005 31.6385L34.8814 18.2564C35.0456 18.0922 35.2683 18 35.5005 18C35.7327 18 35.9554 18.0922 36.1196 18.2564C36.2837 18.4206 36.376 18.6433 36.376 18.8755C36.376 19.1077 36.2837 19.3304 36.1196 19.4945Z"
                fill="#00C000"
            />
        </svg>
    );
};

export default IconCircleCheck;
